export const userConstants = {
    REGISTER_REQUEST:     'USERS_REGISTER_REQUEST',
    REGISTER_SUCCESS:     'USERS_REGISTER_SUCCESS',
    REGISTER_FAILURE:     'USERS_REGISTER_FAILURE',

    PASSWORD_REQUEST:     'USERS_PASSWORD_REQUEST',
    PASSWORD_SUCCESS:     'USERS_PASSWORD_SUCCESS',
    PASSWORD_FAILURE:     'USERS_PASSWORD_FAILURE',

    GET_CONSENT_REQUEST:     'USERS_GET_CONSENT_REQUEST',
    GET_CONSENT_SUCCESS:     'USERS_GET_CONSENT_SUCCESS',
    GET_CONSENT_FAILURE:     'USERS_GET_CONSENT_FAILURE',

    LOG_CONSENT_REQUEST:     'USERS_LOG_CONSENT_REQUEST',
    LOG_CONSENT_SUCCESS:     'USERS_LOG_CONSENT_SUCCESS',
    LOG_CONSENT_FAILURE:     'USERS_LOG_CONSENT_FAILURE',
}